export default "__VITE_ASSET__GeuhNsBC__"